
<template>
  <div class="container highlights-wrap">
    <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
      <div class="highlights-list">
        <router-link
          :to="$store.getters.getSingleUrl(box, 1)"
          class="highlights-box fadeUp"
          :class="animate ? 'animate' : '' "
          :data-highlight="box.financial_highlights_category"
          v-for="(box, index) in itemData"
          :key="index"
         >
<!--          v-if="_.get($store.state.current_content, 'primary.0.id') != box.id"-->
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(box, 'image_background.0.devices.mobile')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(box, 'image_background.0.devices.tablet')"
            />
            <img
              v-if="_.get(box, 'image_background')"
              :src="_.get(box, 'image_background.0.devices.desktop')"
              class="img-absolute"
              alt
            />
          </picture>
          <span class="img-layer"></span>
          <div class="top">
            <h2 class="noto-semibold ttl">{{ box.title }}</h2>
            <div class="icon">
              <img
                v-if="_.get(box, 'icon_regular')"
                :src="
                  _.get(box, [
                    'icon_regular',
                    Object.keys(box.icon_regular)[0],
                    'url',
                  ])
                "
                alt
                class="img-absolute"
              />
              <img
                v-if="_.get(box, 'icon_hover')"
                :src="
                  _.get(box, [
                    'icon_hover',
                    Object.keys(box.icon_hover)[0],
                    'url',
                  ])
                "
                alt
                class="img-absolute"
              />
            </div>
          </div>

          <div class="txt">{{ _.get(box, "content.teaser") }}</div>

          <div class="bottom">
            <div class="line-wrap">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="726.5"
                height="0.5"
                viewBox="0 0 726.5 0.5"
              >
                <line
                  id="Line_27"
                  data-name="Line 27"
                  x2="726"
                  transform="translate(0.25 0.25)"
                  fill="none"
                  stroke="#bcbec0"
                  stroke-linecap="round"
                  stroke-width="0.5"
                  stroke-dasharray="10"
                />
              </svg>
            </div>

            <div class="whiteRed-btn">
              <span
                class="noto-semibold"
                v-if="
                  !($store.state.selected_menu.css.indexOf('english-only') == 1)
                "
                >{{ $fn.tr("get it today") }}</span
              >
              <span
                class="noto-semibold"
                v-if="
                  _.get($store.state.selected_menu, 'css') &&
                  $store.state.selected_menu.css.indexOf('english-only') == 1
                "
                >{{ $fn.tr("get it today english only") }}</span
              >
            </div>
          </div>
        </router-link>
      </div>
    </intersect>
  </div>
</template>

<script>
import Intersect from 'vue-intersect'
export default {
  props: {
    itemData: {
      type: Array,
      require: true,
    },
  },
  components: {
    Intersect
  },
  data() {
    return {
      animate: false,
    };
  },
  computed: {},
};
</script>

